import React from 'react';
import PropTypes from 'prop-types';
const Radio = ({ type = 'radio', name, id, checked, access, onChange }) => (
  <input type={type} name={name} id={id} checked={checked} onChange={onChange} disabled={access} />
);

Radio.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  access: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
}

export default Radio;